import React, { useState } from "react";
import Announcements from "./ParentAnnouncements";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import Parents from "./imageFiles/Parents.png";

export default function ParentStarting({ allRecentAnnouncements, weeklyAnnouncements, monthlyAnnouncements, parent_dashboard_initial_loading }) {

  const [userName, setUserName] = useState(sessionStorage.getItem("username"))

  return (
    <div className="parent-starting p-3">
      <div className="mb-3 Parent-info">
        <p className="helloParent">Hello, {userName || "N/A"} 😄 !</p>
        <p className="address">See your registered students here</p>
        <div className="d-flex justify-content-center">
          <img
            src={Parents}
            alt="Parent"
            className="family-image"
          />
        </div>
      </div>
      <div className="announcement-section">
        <Announcements
          allRecentAnnouncements={allRecentAnnouncements}
          weeklyAnnouncements={weeklyAnnouncements}
          monthlyAnnouncements={monthlyAnnouncements}
          parent_dashboard_initial_loading={parent_dashboard_initial_loading}
        />
      </div>
    </div>
  );
}
